module.exports = __webpack_public_path__ + "img/logo.8ecfe83a.png";